import React from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import photos from "../utils/loadImages";

const Aesthetics = () => {
	return (
		<Container disableGutters>
			<Typography
				variant="h5"
				align="left"
				sx={{ fontWeight: "bold" }}
				gutterBottom
			>
				Aesthetics
			</Typography>
			<Box display="flex" flexWrap="wrap" justifyContent="space-around" gap={3}>
				{photos.slice(1, 3).map((photo, index) => (
					<Box key={index} flexBasis={{ xs: "100%", sm: "30%" }}>
						<Link to="/blog" style={{ textDecoration: "none" }}>
							<img src={photo} alt={`${index + 1}`} style={{ width: "100%" }} />
						</Link>
					</Box>
				))}
				{photos.slice(6, 7).map((photo, index) => (
					<Box key={index} flexBasis={{ xs: "100%", sm: "30%" }}>
						<Link to="/blog" style={{ textDecoration: "none" }}>
							<img src={photo} alt={`${index + 1}`} style={{ width: "100%" }} />
						</Link>
					</Box>
				))}
			</Box>
			<Box textAlign="center" marginTop="20px">
				<Button
					variant="contained"
					href="/blog"
					sx={{
						borderRadius: "20px",
						backgroundColor: "#383838",
						color: "#ffffff",
						"&:hover": {
							backgroundColor: "#4a4a4a"
						}
					}}
				>
					View More
				</Button>
			</Box>
		</Container>
	);
};

export default Aesthetics;
